const waitForController = async (registration) => {
  const updateInProgress = registration.installing || registration.waiting
  if (navigator.serviceWorker.controller && !updateInProgress) {
    return
  }

  await new Promise((resolve) => {
    const finish = () => {
      window.clearTimeout(timeoutId)
      navigator.serviceWorker.removeEventListener('controllerchange', finish)
      resolve()
    }
    const timeoutId = window.setTimeout(finish, 3000)
    navigator.serviceWorker.addEventListener('controllerchange', finish)
    navigator.serviceWorker.ready.catch(finish)
  })
}

export const registerMediaCacheServiceWorker = async () => {
  if (process.env.NODE_ENV !== 'production') {
    return null
  }

  if (!('serviceWorker' in navigator)) {
    return null
  }

  const isSecureContext =
    window.isSecureContext ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'

  if (!isSecureContext) {
    return null
  }

  try {
    const registration = await navigator.serviceWorker.register('/media-cache-sw.js', {
      scope: '/',
      updateViaCache: 'none'
    })
    if (navigator.serviceWorker.controller) {
      await registration.update()
    }
    await waitForController(registration)

    if (navigator.storage?.persist) {
      navigator.storage.persist().catch(() => {})
    }

    return registration
  } catch (error) {
    console.warn('Media cache service worker registration failed:', error)
    return null
  }
}
